import type { JSX } from 'react'

import { Input } from '../design-system/input.tsx'
import { readEmailTo } from '../lib/alert-email-to.ts'

/**
 * The addresses an emailing alert goes to, as one text field.
 *
 * @param props - Field props.
 * @param props.value - What the field holds.
 * @param props.onChange - Sets what the field holds.
 * @param props.data-testid - The field's test id.
 * @returns The field.
 */
export function EmailToField({
  value,
  onChange,
  'data-testid': testId
}: {
  value: string
  onChange: (value: string) => void
  'data-testid': string
}): JSX.Element {
  const read = readEmailTo(value)

  return (
    <Input
      data-testid={testId}
      label="Email to"
      value={value}
      onChange={event => onChange(event.target.value)}
      error={read.ok ? undefined : read.problem}
      hint="Separate addresses with commas. BlytzPay addresses only. Blank sends to you."
    />
  )
}
